import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-savingsprematuritybreaking',
  templateUrl: './savingsprematuritybreaking.component.html',
  styleUrls: ['./savingsprematuritybreaking.component.css']
})
export class SavingsprematuritybreakingComponent implements OnInit {

  @Output() saveForm = new EventEmitter();
  @Input('product') product = {
    SAVINGS_PRODUCT_ID: '0'
  };
  @Input('breaking') breaking = {
    ENABLE_PREMATURITY_BREAKING: false,
    FINES_PERCENT_VALUE:'0',
    FINES_FLAT_VALUE:'0',
    LOCK_SAVINGS:true
  };
  @Input('loading') loading = false;
  constructor() { }

  ngOnInit() {

  }
  saveFines(value, valid) {
    this.saveForm.emit({ value: value, valid: valid });
  }

}
